import { Container } from "./style";
import HWW from '../../../../assets/img/Langding/HWW.png'

const HowWeWork = () => {
  return (
    <Container>
      <div>
        <h1>How We Work</h1>
        <p>Forest owners register lands on Green Foundation.</p>
        <p>
          Environment Advocates provide funding through staking in our
          ecosystem.
        </p>
        <p>Green Foundation start tree-planting project on the land.</p>
        <p>
          Once the reforestation goals have been met, Green Foundation receive
          Carbon Certificates,which are then tokenized and divided fairly among.
        </p>
        <button>LET’S GO</button>
      </div>
      <img src={HWW} alt=""/>
    </Container>
  );
};
export default HowWeWork;
